import { useState } from 'react'
import { api, ErroApi } from '../lib/api'
import { Marca } from '../componentes/Marca'
import './entrar.css'

/**
 * Criar a conta de administrador da plataforma.
 *
 * Chega-se aqui por um link gerado no servidor, que vale uma vez e
 * expira em 24 horas. Não existe rota pública de "criar admin" — seria
 * a porta mais óbvia do sistema.
 *
 * A tela diz o que essa conta é, em voz alta, antes de a pessoa criar
 * a senha. Quem não sabe o que está protegendo escolhe senha de login
 * comum.
 */
export function Fundador({ token }: { token: string }) {
  const [senha, setSenha] = useState('')
  const [repete, setRepete] = useState('')
  const [erro, setErro] = useState<string | null>(null)
  const [pronto, setPronto] = useState<{ email: string; nome: string } | null>(null)
  const [enviando, setEnviando] = useState(false)

  const curta = senha.length > 0 && senha.length < 12
  const difere = repete.length > 0 && senha !== repete

  async function submeter(e: React.FormEvent) {
    e.preventDefault()
    setErro(null); setEnviando(true)
    try {
      setPronto(await api<{ email: string; nome: string }>(
        '/v1/admin/aceitar-convite', { metodo: 'POST', corpo: { token, senha } }))
    } catch (err) {
      setErro(err instanceof ErroApi
        ? err.message
        : 'Não foi possível criar a conta.')
      setEnviando(false)
    }
  }

  if (pronto) {
    return (
      <main className="entrar">
        <div className="entrar__caixa cartao">
          <Marca tamanho={30} />
          <div>
            <h1>Conta criada</h1>
            <p className="ajuda">
              {pronto.nome} · {pronto.email}
            </p>
          </div>
          <div className="aviso aviso--ok">
            Guarde essa senha num gerenciador. Não há recuperação por e-mail
            para conta de administrador — de propósito.
          </div>
          <a className="botao" href="/admin" style={{ textAlign: 'center' }}>
            Ir para o painel
          </a>
        </div>
      </main>
    )
  }

  return (
    <main className="entrar">
      <form className="entrar__caixa cartao" onSubmit={submeter}>
        <Marca tamanho={30} />
        <div>
          <h1>Conta de administrador</h1>
          <p className="ajuda">Da plataforma, não de uma clínica.</p>
        </div>

        {/* Dito antes de a pessoa escolher a senha, não depois. */}
        <div className="aviso aviso--atencao">
          Esta conta enxerga <strong>todas as clínicas</strong> e altera assinaturas.
          Escolha uma senha que você não usa em nenhum outro lugar.
        </div>

        {erro && <div className="aviso aviso--erro" role="alert">{erro}</div>}

        <div className="campo">
          <label htmlFor="f-senha">Senha</label>
          <input id="f-senha" className="entrada" type="password" required autoFocus
                 autoComplete="new-password" minLength={12}
                 aria-invalid={curta}
                 value={senha} onChange={(e) => setSenha(e.target.value)} />
          <span className={curta ? 'ajuda ajuda--erro' : 'ajuda'}>
            {curta
              ? `${senha.length} de 12 caracteres, no mínimo.`
              : 'Mínimo de 12 caracteres. Frase longa vale mais que símbolo.'}
          </span>
        </div>

        <div className="campo">
          <label htmlFor="f-repete">Repita a senha</label>
          <input id="f-repete" className="entrada" type="password" required
                 autoComplete="new-password"
                 aria-invalid={difere}
                 value={repete} onChange={(e) => setRepete(e.target.value)} />
          {difere && <span className="ajuda ajuda--erro">As duas não conferem.</span>}
        </div>

        <button className="botao" type="submit"
                disabled={enviando || curta || difere || !senha || !repete}>
          {enviando ? 'Criando…' : 'Criar conta de administrador'}
        </button>
      </form>
    </main>
  )
}
